<template>
    <div>
        <Header :headerData="headerData"></Header>

        <div class="query_box" >
            <a-input 
                v-model:value="query.user_name" 
                allowClear 
                :placeholder="t('user.user_name')" 
                style="width: 200px; margin: 10px 10px 10px 0" 
                @change="handleInputChange()"
            />
            <a-input 
                v-model:value="query.email" 
                allowClear 
                :placeholder="t('user.email')" 
                style="width: 220px; margin: 10px 10px 10px 0" 
                @change="handleInputChange()"
            />
            <a-select 
                v-model:value="query.status" 
                allowClear 
                :placeholder="t('user.status')" 
                style="width: 180px; margin: 10px 10px 10px 0"
                :options="statusOptions"
                @change="handleInputChange()"
            >
                <!-- <a-select-option v-for="opt in statusOptions" :key="opt.value" :value="opt.value">
                    {{ opt.label }}
                </a-select-option> -->
            </a-select>
            <a-select 
                v-model:value="query.category" 
                allowClear 
                :placeholder="t('user.category')" 
                style="width: 200px; margin: 10px 10px 10px 0"
                :options="categoryOptions"
                @change="handleInputChange()"
            >
                <!-- <a-select-option v-for="opt in categoryOptions" :key="opt.value" :value="opt.value">
                    {{ opt.label }}
                </a-select-option> -->
            </a-select>
            <a-select 
                v-model:value="query.platform" 
                allowClear 
                :placeholder="t('user.platform')" 
                style="width: 200px; margin: 10px 10px 10px 0"
                :options="platformOptions"
                @change="handleInputChange()"
            >
                <!-- <a-select-option v-for="opt in platformOptions" :key="opt.value" :value="opt.value">
                    {{ opt.label }}
                </a-select-option> -->
            </a-select>
            <a-select 
                v-model:value="query.user_source" 
                allowClear 
                :placeholder="t('user.user_source')" 
                style="width: 200px; margin: 10px 10px 10px 0"
                :options="userSourceOptions"
                @change="handleInputChange()"
            >
                <!-- <a-select-option v-for="opt in userSourceOptions" :key="opt.value" :value="opt.value">
                    {{ opt.label }}
                </a-select-option> -->
            </a-select>
            <a-button type="primary" size="small" style="margin: 10px 10px 10px 0" @click="handleSearch">
                <img src="@/assets/image/search.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                {{ $t('base.search') }}
            </a-button>
        </div>

        <!-- 表格 -->
        <Table
            ref="tableRef"
            :table="table"
            @handleChangePagination="handleChangePagination"
        >
            <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'email'">
                    {{ props.record.email }}
                    <EyeInvisibleOutlined v-if="props.record.show_sensitive_email && props.record.email !== '-'" style="float:right;margin-top:4px" @click="handle('showSensitiveData', props.record)"/>
                    <EyeOutlined v-if="!props.record.show_sensitive_email && props.record.email !== '-'" style="float:right;margin-top:4px" @click="handle('hideSensitiveData', props.record)"/>
                </template>
                <template v-if="props.column.key === 'mobile'">
                    {{ props.record.mobile }}
                    <EyeInvisibleOutlined v-if="props.record.show_sensitive_mobile && props.record.mobile !== '-'" style="float:right;margin-top:4px" @click="handle('showSensitiveMobile', props.record)"/>
                    <EyeOutlined v-if="!props.record.show_sensitive_mobile && props.record.mobile !== '-'" style="float:right;margin-top:4px" @click="handle('hideSensitiveMobile', props.record)"/>
                </template>
                <template v-if="props.column.key === 'action'">
                    <a-button size="small" @click="handle('log', props.record)">{{ $t('access.log') }}</a-button>
                    <a-divider type="vertical" />
                    <a-button size="small" @click="handle('versionRecord',props.record)">{{ $t('user.versionRecord') }}</a-button>
                </template>
            </template>
        </Table>

        <!-- 登录日志弹窗 -->
        <a-modal 
            v-model:visible="logVisible" 
            :title="$t('access.log')" 
            :footer="null"
            :width="1060"
            centered
            :maskClosable="false"
            @cancel="handleCloseLog"
        >
            <div style="margin:12px 0; display:flex; align-items:center; gap:8px;">
                <a-select 
                    v-model:value="signTypeFilter" 
                    allowClear 
                    :placeholder="t('user.sign_type')" 
                    style="width: 180px;"
                    @change="onChangeLogSignType"
                >
                    <a-select-option v-for="opt in logSignTypeOptions" :key="opt.value" :value="opt.value">
                        {{ opt.label }}
                    </a-select-option>
                </a-select>
            </div>
            <a-table 
                :dataSource="logTable.data" 
                :columns="logTable.columns" 
                :loading="logLoading"
                :pagination="false"
                size="small"
                rowKey="idx"
            />
            <div style="text-align:left;margin-top:16px;">
                <a-pagination 
                    size="small"
                    :current="logPagination.current"
                    :pageSize="logPagination.pageSize"
                    :total="logPagination.total"
                    :showSizeChanger="false"
                    :show-total="showLogTotal"
                    @change="onLogPageChange"
                />
            </div>
        </a-modal>


        <!-- 隐私协议版本列表 -->
        <a-modal
            v-model:open="versionVisible"
            :title="t('user.versionRecord')"
            width="80%"
            placement="right"
            :footer="null"
        >

        <a-tabs v-model:activeKey="activeKey">
            <a-tab-pane key="1" :tab="t('user.privacy_policy_version')"></a-tab-pane>
            <a-tab-pane key="2" :tab="t('user.login_record')"></a-tab-pane>
        </a-tabs>

            <PrivacyVersionList v-if="versionVisible && activeKey === '1'" :row="rowData" :tenantOptions="tenantOptions"></PrivacyVersionList>
            <LoginRecordList v-if="versionVisible && activeKey === '2'" :row="rowData" :tenantOptions="tenantOptions"></LoginRecordList>
        </a-modal>
    </div>
    
</template>

<script setup>
    import { onMounted, ref, reactive, h } from "vue";
    import { useI18n } from 'vue-i18n'
    import { message } from 'ant-design-vue'
    import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons-vue'
    import Header from "@/layouts/component/Header.vue";
    import Table from "@/components/Table.vue";
    import { getWeek } from '@/hooks/useGetWeek'
    import { formatTimestamp, getFieldVal, debounce } from '@/utils/global'
    import { UserApi } from '@/api/UserApi.js'
    import { UserApi as SignApi } from '@/api/UserApi.js'
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js'
    import PrivacyVersionList from "./PrivacyVersionList.vue";
    import LoginRecordList from "./LoginRecordList.vue";

    const { t } = useI18n()

    const headerData = ref({
        menu:'menu.User',
        menu_desc: 'menu.subUser',
        week: getWeek().week,
        current_time: getWeek().currentDate,
    })

    const tableRef = ref(null)
    const activeKey = ref('1')
    const rowData = ref({})
    const versionVisible = ref(false)
    const logVisible = ref(false)
    const logLoading = ref(false)
    const currentUserId = ref(null) // 用于获取日志列表
    const currentRowId = ref(null)  // 用于解敏（还原）接口 path id
    const logPagination = ref({ current:1, pageSize:10, total:0 })
    const showLogTotal = (total) => t('base.total') + ` ${total} ` + t('base.row')
    const signTypeFilter = ref(undefined)
    const tenantOptions = reactive({})
    const logSignTypeOptions = ref([
        { value: 0, label: t('user.log_in') },
        { value: 1, label: t('user.log_out') },
        { value: 2, label: t('user.registration') },
        { value: 3, label: t('user.verification_code') },
        { value: 4, label: t('user.delete_user') },
        { value: 5, label: t('user.create_backend') },
    ])


    const renderLogEmail = ({ text, record }) => {
        const nodes = [ h('span', null, text) ]
        const canToggle = record.email_desensitize && record.email !== '-'
        if(canToggle){
            const icon = record.show_sensitive_email
                ? h(EyeInvisibleOutlined, { style:'float:right;margin-top:4px', onClick: () => handle('logShowEmail', record) })
                : h(EyeOutlined, { style:'float:right;margin-top:4px', onClick: () => handle('logHideEmail', record) })
            nodes.push(icon)
        }
        return h('div', null, nodes)
    }

    const logTable = ref({
        data:[],
        columns:[
            { title: t('user.email'), dataIndex: 'email', key: 'email', width: 350, customRender: renderLogEmail,align: 'center' },
            { title: t('user.sign_type'), dataIndex: 'sign_type_text', key: 'sign_type',align: 'center' },
            { title: t('user.sign_time'), dataIndex: 'sign_time', key: 'sign_time', align: 'center' },
        ]
    })

    const query = ref({
        user_name: '',
        email: '',
        status: undefined,
        category: undefined,
        platform: undefined,
        user_source: undefined,
    })

    const userSourceOptions = ref([
        { value: 0, label: t('user.app') },
        { value: 1, label: t('user.backend') },
        { value: 2, label: t('user.serviceTool') },
    ])

    const statusOptions = ref([
        { value: 0, label: t('user.activated') },
        { value: 1, label: t('user.unactivated') },
    ])

    const categoryOptions = ref([
        { value: 0, label: t('user.appBuilt') },
        { value: 1, label: t('user.commonUser') },
        { value: 2, label: t('user.google') },
        { value: 3, label: t('user.apple') },
        { value: 4, label: t('user.facebook') },
        { value: 5, label: t('user.lark') },
    ])

    const platformOptions = ref([
        { value: 0, label: t('user.app') },
        { value: 1, label: t('user.backend') },
        { value: 2, label: t('user.serviceTool') },
        { value: 3, label: t('user.general') },
    ])

    const table = ref({
        data: [],
        columns: [
            { title: t('user.user_name'), dataIndex: 'user_name', key: 'user_name', width: 160, resizable: true, ellipsis: true, fixed: 'left' },
            { title: t('user.email'), dataIndex: 'email', key: 'email', width: 280, resizable: true, ellipsis: true },
            { title: t('user.mobile'), dataIndex: 'mobile', key: 'mobile', width: 220, resizable: true, ellipsis: true },
            // { title: t('user.gender'), dataIndex: 'gender_text', key: 'gender_text', width: 100, resizable: true, ellipsis: true },
            { title: t('user.city'), dataIndex: 'city', key: 'city', width: 140, resizable: true, ellipsis: true },
            // { title: t('user.street_no'), dataIndex: 'street_no', key: 'street_no', width: 180, resizable: true, ellipsis: true },
            { title: t('user.zip_code'), dataIndex: 'zip_code', key: 'zip_code', width: 120, resizable: true, ellipsis: true },
            // { title: t('user.first_name'), dataIndex: 'first_name', key: 'first_name', width: 140, resizable: true, ellipsis: true },
            // { title: t('user.last_name'), dataIndex: 'last_name', key: 'last_name', width: 140, resizable: true, ellipsis: true },
            { title: t('user.status'), dataIndex: 'status_text', key: 'status_text', width: 120, resizable: true, ellipsis: true },
            { title: t('user.category'), dataIndex: 'category_text', key: 'category_text', width: 140, resizable: true, ellipsis: true },
            { title: t('user.platform'), dataIndex: 'platform_text', key: 'platform_text', width: 140, resizable: true, ellipsis: true },
            { title: t('user.tenant_admin'), dataIndex: 'tenant_admin_text', key: 'tenant_admin_text', width: 140, resizable: true, ellipsis: true },
            { title: t('user.user_source'), dataIndex: 'user_source_text', key: 'user_source_text', width: 140, resizable: true, ellipsis: true },
            { title: t('user.create_time'), dataIndex: 'create_time_text', key: 'create_time_text', width: 180, resizable: true, ellipsis: true },
            { title: t('base.operate'), key: 'action', fixed: 'right', width: 200, resizable: true },
        ],
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 2100,
                y: 580,
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                // showTotal:()=>t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    const handle = (type, row) => {
        switch(type){
            case 'log':
                currentUserId.value = row.user_id
                currentRowId.value = row.id || row.user_id
                logPagination.value.current = 1
                openLogModal()
                break;
            case 'versionRecord':
                versionVisible.value = true
                rowData.value = row
                activeKey.value = '1'
                break;
            case 'showSensitiveData':
                desensitizedData(row, 'email')
                break;
            case 'hideSensitiveData':
                row.email = row?.email_desensitize?.value ?? row.email
                row.show_sensitive_email = true
                break;
            case 'showSensitiveMobile':
                desensitizedData(row, 'mobile')
                break;
            case 'hideSensitiveMobile':
                row.mobile = row?.mobile_desensitize?.value ?? row.mobile
                row.show_sensitive_mobile = true
                break;
            case 'logShowEmail':
                desensitizeLogEmail(row)
                break;
            case 'logHideEmail':
                row.email = row?.email_desensitize?.value ?? row.email
                row.show_sensitive_email = true
                break;
            
        }
    }

    // 分页
    const handleChangePagination =  (config)=> {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getList()
    }

    const handleInputChange = debounce(()=>{
        table.value.configs.pagination.current = 1
        getList()
    }, 500)

    const handleSearch = ()=>{
        table.value.configs.pagination.current = 1
        getList()
    }

    const mapSignType = (val)=>{
        if(val === 0) return t('user.log_in')
        if(val === 1) return t('user.log_out')
        if(val === 2) return t('user.registration')
        if(val === 3) return t('user.verification_code')
        if(val === 4) return t('user.delete_user')
        if(val === 5) return t('user.create_backend')
        return '-'
    }

    const mapGender = (val)=>{
        if(val === 1) return t('user.male')
        if(val === 2) return t('user.female')
        return '-'
    }

    const mapUserSource = (val)=>{
        if(val === 0) return t('user.app')
        if(val === 1) return t('user.backend')
        if(val === 2) return t('user.serviceTool')
        return '-'
    }

    const mapStatus = (val)=>{
        if(val === 0) return t('user.activated')
        if(val === 1) return t('user.unactivated')
        return '-'
    }

    const mapCategory = (val)=>{
        if(val === 0) return t('user.appBuilt')
        if(val === 1) return t('user.commonUser')
        if(val === 2) return t('user.google')
        if(val === 3) return t('user.apple')
        if(val === 4) return t('user.facebook')
        if(val === 5) return t('user.lark')
        return '-'
    }

    const mapPlatform = (val)=>{
        if(val === 0) return t('user.app')
        if(val === 1) return t('user.backend')
        if(val === 2) return t('user.serviceTool')
        if(val === 3) return t('user.general')
        return '-'
    }

    const mapTenantAdmin = (val)=>{
        if(val === 0) return t('base.yes')
        if(val === 1) return t('base.no')
        return '-'
    }

    const getList = async () => {
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let params = {
            user_name: (query.value.user_name || '').trim(),
            email: (query.value.email || '').trim(),
            status: query.value.status,
            category: query.value.category,
            platform: query.value.platform,
            user_source: query.value.user_source,
        }
        let res = await UserApi.getInstance().getUserList(params, page_num, page_size) 
        if(Array.isArray(res?.data?.records)){
            const records = Array.isArray(res?.data?.records) ? res.data.records : (Array.isArray(res?.data?.list) ? res.data.list : [])
            table.value.data = records.map((item)=>{
                const u = item || {}
                return {
                    id: u.id || item.id, // 行 key
                    user_id: u.user_id,
                    user_name: getFieldVal(u.user_name),
                    email: getFieldVal(u.email),
                    email_desensitize: u.email_desensitize,
                    show_sensitive_email: true,
                    mobile: getFieldVal(u.mobile),
                    mobile_desensitize: u.mobile_desensitize,
                    show_sensitive_mobile: true,
                    gender_text: mapGender(u.gender),
                    city: getFieldVal(u.city),
                    street_no: getFieldVal(u.street_no),
                    zip_code: getFieldVal(u.zip_code),
                    // first_name: getFieldVal(u.first_name),
                    // last_name: getFieldVal(u.last_name),
                    status_text: mapStatus(u.status),
                    category_text: mapCategory(u.category),
                    platform_text: mapPlatform(u.platform),
                    tenant_admin_text: mapTenantAdmin(u.tenant_admin),
                    user_source_text: mapUserSource(u.user_source),
                    create_time_text: formatTimestamp(u.create_timestamp),
                    // 详情抽屉字段
                    country: getFieldVal(u.country),
                    subdivisions: getFieldVal(u.subdivisions),
                    time_zone: getFieldVal(u.time_zone),
                    ip_address: getFieldVal(u.ip_address),
                    trigger_timestamp: u.trigger_timestamp,
                    latitude: (u.latitude === 0 || u.latitude) ? u.latitude : '-',
                }
            })
            table.value.configs.pagination.total = res.data.total || 0
            table.value.configs.loading = false
        }else{
            message.error(res.msg || res.message)
            table.value.configs.loading = false
        }
    }

    // 脱敏数据（解敏显示完整邮箱）
    const desensitizedData = async (row, key) => {
        const param = {
            request_param: JSON.stringify(key === 'mobile' ? (row.mobile_desensitize || {}) : (row.email_desensitize || {}))
        }
        const id = row.id
        let res = await AdvancedFunApi.getInstance().desensitizedData(param, id)
        if(res.code === 0 || res.code === 200){
            if(key === 'email'){
                row.email = res.data
                row.show_sensitive_email = false
            }
            if(key === 'mobile'){
                row.mobile = res.data
                row.show_sensitive_mobile = false
            }
        }else{
            message.error(res.msg || t('base.getDataFail'))
        }
    }

    const openLogModal = async ()=>{
        logVisible.value = true
        await getSignLogList()
    }

    const handleCloseLog = ()=>{
        logVisible.value = false
        logTable.value.data = []
        currentUserId.value = null
        currentRowId.value = null
    }

    const onLogPageChange = async (page)=>{
        logPagination.value.current = page
        await getSignLogList()
    }

    const getSignLogList = async ()=>{
        logLoading.value = true
        const page = logPagination.value.current
        const size = logPagination.value.pageSize
        const param = { user_id: currentUserId.value, sign_type: signTypeFilter.value }
        let res = await SignApi.getInstance().getSignLogList(param, page, size)
        if(res.code === 0 || res.code === 200){
            const list = Array.isArray(res?.data?.records) ? res.data.records : []
            logTable.value.data = list.map((i, idx)=>({
                idx: `${page}-${idx}`,
                id: i.id,
                email: getFieldVal(i.email),
                email_desensitize: i.email_desensitize,
                show_sensitive_email: true,
                sign_type_text: mapSignType(i.sign_type),
                sign_time: getFieldVal(i.sign_time),
            }))
            logPagination.value.total = res?.data?.total || 0
        }else{
            message.error(res.msg || t('base.getDataFail'))
        }
        logLoading.value = false
    }

    const onChangeLogSignType = ()=>{
        logPagination.value.current = 1
        getSignLogList()
    }

    const desensitizeLogEmail = async (row) => {
        const param = { request_param: JSON.stringify(row.email_desensitize || {}) }
        const id = row.id
        let res = await AdvancedFunApi.getInstance().desensitizedData(param, id)
        if(res.code === 0){
            row.email = res.data
            row.show_sensitive_email = false
        }else{
            message.error(res.msg || t('base.getDataFail'))
        }
    }

    // 获取租户列表
    const getTenantList = async()=>{
        let param = {
            limit_size: 100,
        }
        let res = await AdvancedFunApi.getInstance().getAllTenant2(param)
        if(res.code == 0){
            res.data.length > 0 && res.data.forEach(item => {
                tenantOptions[item.tenant_id] = item.tenant_name
            })
        }
    }

    onMounted(()=>{
        getList()
        getTenantList()
    })

</script>

<style lang="scss" scoped>
.query_box{
    margin: 30px 0 10px;
}
::v-deep .ant-table-wrapper .ant-table-thead>tr>th, 
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td, 
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}

::v-deep .page_header .week{
    margin-top: -55px;
    transform: translateY(8px);
}
::v-deep .page_header .admin_email{
    margin-top: -55px;
    transform: translateY(18px);
}

// 当sub不为空时
// ::v-deep .page_header .week{
//     margin-top: -70px;
// }
// ::v-deep .page_header .admin_email{
//     margin-top: -60px;
// }
</style>